import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getLocateList, getTerminalList } from "../../api/terminalApi";
import styled from "styled-components";
import {
  Avatar,
  Flex,
  Input,
  Pagination,
  Popover,
  Select,
  Table,
} from "@mantine/core";

function TabletTable() {
  const [tableData, setTableData] = useState<any>();
  const navigate = useNavigate();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  //for select
  const [selectData, setSelectData] = useState<any>();
  const [selectedLocate, setSelectedLocate] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();
  const { id } = useParams(); 

  const getTableData = async () => {
    try {
      const { data }: any = await getTerminalList({
        pageNumber: page,
        limit: limit,
        sort,
        locate: selectedLocate,
        name: searchedName,
        companyId: id as string,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };
  const getLocates = async () => {
    try {
      const { data }: any = await getLocateList({
        companyId: id as string,
      });
      setSelectData(data);
    } catch (error) {}
  };
  useEffect(() => {
    if (page) {
      //navigate(`?page=${page}&limit=${limit}`, { replace: true });
      getTableData();
    }
  }, [page, searchedName, sort, selectedLocate]);

  useEffect(() => {
    getLocates();
  }, []);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ overflowY: "auto", minHeight: "450px", width: "100%" }}>
          <Table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px 4px",
            }}
            verticalSpacing="sm"
            withRowBorders={false}
          >
            <Table.Thead>
              <Table.Tr>
                <StyledTableTh style={{ width: "30%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Tablet Adı</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                    <Popover position="right" shadow="md">
                      <Popover.Target>
                        <div style={{ width: "max-content" }}>
                          <Avatar
                            style={{
                              cursor: "pointer",
                            }}
                            src={"/assets/searchIcon.png"}
                            size={16}
                          />
                        </div>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Input
                          value={searchedName}
                          onChange={(event) => {
                            {
                              setPage(1);
                              setSearchedName(event.currentTarget.value);
                            }
                          }}
                        />
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>
                  Tablet Kodu
                </StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>
                  <Flex>
                    <StyledSelect
                      variant="unstyled"
                      placeholder="Tablet Konumu"
                      data={selectData}
                      onChange={(e) => {
                        setSelectedLocate(e);
                        setPage(1);
                      }}
                    />
                  </Flex>
                </StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody style={{ backgroundColor: "#FBFBFB" }}>
              {tableData?.map((terminal: any) => (
                <Table.Tr
                  style={{
                    color: "#1D1B20",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  bg={"#F9F9F9"}
                  key={terminal._id}
                >
                  <Table.Td style={{ width: "30%" }}>{terminal.name}</Table.Td>
                  <Table.Td style={{ width: "25%" }}>
                    {terminal.terminalCode}
                  </Table.Td>
                  <Table.Td style={{ width: "25%" }}>
                    {terminal.location}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </div>

        <div
          style={{
            position: "absolute",
            bottom: "15px",
          }}
        >
          <Pagination
            total={totalPages}
            value={page}
            onChange={setPage}
            withEdges
            color="#5C26FF"
            radius="xl"
          />
        </div>
      </div>
    </>
  );
}

export default TabletTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledSelect = styled(Select)`
  .mantine-Input-input {
    width: 100% !important;
    &::placeholder {
      color: #4c4c4c;
    }
  }
`;
